const Categories = [

  {
    category: "General Knowledge",
    image: "https://ik.imagekit.io/ashutosh/Quiz/gk?ik-sdk-version=javascript-1.4.3&updatedAt=1650104232536",
    value: 9
  },

  {
    category: "Books",
    image: "https://ik.imagekit.io/ashutosh/Quiz/books?ik-sdk-version=javascript-1.4.3&updatedAt=1650104489027",
    value: 10
  },

  {
    category: "Films",
    image: "https://ik.imagekit.io/ashutosh/Quiz/film?ik-sdk-version=javascript-1.4.3&updatedAt=1650104573194",
    value: 11
  },

  {
    category: "Music",
    image: "https://ik.imagekit.io/ashutosh/Quiz/music?ik-sdk-version=javascript-1.4.3&updatedAt=1650104314939",
    value: 12
  },

  {
    category: "Theaters & Musicals",
    image: "https://ik.imagekit.io/ashutosh/Quiz/theater?ik-sdk-version=javascript-1.4.3&updatedAt=1650104265858",
    value: 13
  },

  {
    category: "Television",
    image: "https://ik.imagekit.io/ashutosh/Quiz/tv?ik-sdk-version=javascript-1.4.3&updatedAt=1650104349704",
    value: 14
  },

  {
    category: "Video Games",
    image: "https://ik.imagekit.io/ashutosh/Quiz/video_games?ik-sdk-version=javascript-1.4.3&updatedAt=1650104438669",
    value: 15
  },

  {
    category: "Board Games",
    image: "https://ik.imagekit.io/ashutosh/Quiz/board_game?ik-sdk-version=javascript-1.4.3&updatedAt=1650104251163",
    value: 16
  },

  {
    category: "Science & Nature",
    image: "https://ik.imagekit.io/ashutosh/Quiz/science?ik-sdk-version=javascript-1.4.3&updatedAt=1650104300429",
    value: 17
  },

  {
    category: "Computer",
    image: "https://ik.imagekit.io/ashutosh/Quiz/computer?ik-sdk-version=javascript-1.4.3&updatedAt=1650104330786",
    value: 18
  },

  {
    category: "Mathematics",
    image: "https://ik.imagekit.io/ashutosh/Quiz/maths?ik-sdk-version=javascript-1.4.3&updatedAt=1650102797756",
    value: 19
  },

  {
    category: "Mythology",
    image: "https://ik.imagekit.io/ashutosh/Quiz/mythology?ik-sdk-version=javascript-1.4.3&updatedAt=1650102462612",
    value: 20
  },

  {
    category: "Sports",
    image: "https://ik.imagekit.io/ashutosh/Quiz/sports?ik-sdk-version=javascript-1.4.3&updatedAt=1650102713570",
    value: 21
  },

  {
    category: "Geography",
    image: "https://ik.imagekit.io/ashutosh/Quiz/geography?ik-sdk-version=javascript-1.4.3&updatedAt=1650102552408",
    value: 22
  },

  {
    category: "History",
    image: "https://ik.imagekit.io/ashutosh/Quiz/history?ik-sdk-version=javascript-1.4.3&updatedAt=1650102732787",
    value: 23
  },

  {
    category: "Politics",
    image: "https://ik.imagekit.io/ashutosh/Quiz/poli?ik-sdk-version=javascript-1.4.3&updatedAt=1650102442823",
    value: 24
  },

  {
    category: "Art",
    image: "https://ik.imagekit.io/ashutosh/Quiz/art?ik-sdk-version=javascript-1.4.3&updatedAt=1650106262318",
    value: 25
  },

  {
    category: "Celebrities",
    image: "https://ik.imagekit.io/ashutosh/Quiz/celeb?ik-sdk-version=javascript-1.4.3&updatedAt=1650102570927",
    value: 26
  },

  {
    category: "Animals",
    image: "https://ik.imagekit.io/ashutosh/Quiz/animal?ik-sdk-version=javascript-1.4.3&updatedAt=1650102511904",
    value: 27
  },

  {
    category: "Vehicles",
    image: "https://ik.imagekit.io/ashutosh/Quiz/Vehicles?ik-sdk-version=javascript-1.4.3&updatedAt=1650106238638",
    value: 28
  },

  {
    category: "Comics",
    image: "https://ik.imagekit.io/ashutosh/Quiz/comics?ik-sdk-version=javascript-1.4.3&updatedAt=1650102654849",
    value: 29
  },

  {
    category: "Gadgets",
    image: "https://ik.imagekit.io/ashutosh/Quiz/gadgets?ik-sdk-version=javascript-1.4.3&updatedAt=1650102782807",
    value: 30
  },

  {
    category: "Japanese Anime",
    image: "https://ik.imagekit.io/ashutosh/Quiz/anime?ik-sdk-version=javascript-1.4.3&updatedAt=1650102695956",
    value: 31
  },

  {
    category: "Cartoon & Animations",
    image: "https://ik.imagekit.io/ashutosh/Quiz/cartoon?ik-sdk-version=javascript-1.4.3&updatedAt=1650102677395",
    value: 32
  },

];

export default Categories;